import React from 'react';
import { useIntl } from 'react-intl';
import DataBox from '../../../Dashboard/DataBox';
import BranchCountersWidget from './BranchCountersWidget';
import UsersCountersWidget from './UsersCountersWidget';
import SectionCountersWidget from './SectionCountersWidget';

const CountersWrapper = function CountersWrapper({
  branchCounters,
  userCounters,
  sectionCounters,
}) {
  const intl = useIntl();
  return (
    <>
      {branchCounters && (
        <DataBox
          title={intl.messages.TOTAL_CALLS_BY_BRANCH}
          widget={<BranchCountersWidget branchCounters={branchCounters} />}
        />
      )}
      {userCounters && (
        <DataBox
          title={intl.messages.TOTAL_CALLS_BY_USER}
          widget={<UsersCountersWidget userCounters={userCounters} />}
        />
      )}
      {sectionCounters && (
        <SectionCountersWidget sectionCounters={sectionCounters} />
      )}
    </>
  );
};

export default CountersWrapper;
